import React from "react";
import AmCharts from "@amcharts/amcharts3-react";
import { Typography } from "material-ui";
import Slide from "material-ui/transitions/Slide";
import { chartDrawn } from "./../../../utilities/charts";

const fakeData = {
  idle: [
    {
      Tiempo: 50,
      Unidad: "TRA 01"
    },
    {
      Tiempo: 40,
      Unidad: "TRA 02"
    },
    {
      Tiempo: 60,
      Unidad: "TRA 03"
    },
    {
      Tiempo: 10,
      Unidad: "TRA 04"
    },
    {
      Tiempo: 70,
      Unidad: "TRA 05"
    },
    {
      Tiempo: 55,
      Unidad: "TRA 06"
    },
    {
      Tiempo: 11,
      Unidad: "TRA 07"
    },
    {
      Tiempo: 5,
      Unidad: "TRA 08"
    },
    {
      Tiempo: 4,
      Unidad: "TRA 09"
    },
    {
      Tiempo: 100,
      Unidad: "TRA 10"
    },
    {
      Tiempo: 3,
      Unidad: "TRA 11"
    },
    {
      Tiempo: 80,
      Unidad: "TRA 12"
    }
  ],
  deadTime: [
    {
      Tiempo: 50,
      Unidad: "TRA 01"
    },
    {
      Tiempo: 40,
      Unidad: "TRA 02"
    },
    {
      Tiempo: 60,
      Unidad: "TRA 03"
    },
    {
      Tiempo: 10,
      Unidad: "TRA 04"
    },
    {
      Tiempo: 70,
      Unidad: "TRA 05"
    },
    {
      Tiempo: 55,
      Unidad: "TRA 06"
    },
    {
      Tiempo: 11,
      Unidad: "TRA 07"
    },
    {
      Tiempo: 5,
      Unidad: "TRA 08"
    },
    {
      Tiempo: 4,
      Unidad: "TRA 09"
    },
    {
      Tiempo: 100,
      Unidad: "TRA 10"
    },
    {
      Tiempo: 3,
      Unidad: "TRA 11"
    },
    {
      Tiempo: 80,
      Unidad: "TRA 12"
    }
  ],
  distanceTraveled: [
    {
      Distancia: 50,
      Unidad: "TRA 01"
    },
    {
      Distancia: 40,
      Unidad: "TRA 02"
    },
    {
      Distancia: 60,
      Unidad: "TRA 03"
    },
    {
      Distancia: 10,
      Unidad: "TRA 04"
    },
    {
      Distancia: 70,
      Unidad: "TRA 05"
    },
    {
      Distancia: 55,
      Unidad: "TRA 06"
    },
    {
      Distancia: 11,
      Unidad: "TRA 07"
    },
    {
      Distancia: 5,
      Unidad: "TRA 08"
    },
    {
      Distancia: 4,
      Unidad: "TRA 09"
    },
    {
      Distancia: 100,
      Unidad: "TRA 10"
    },
    {
      Distancia: 3,
      Unidad: "TRA 11"
    },
    {
      Distancia: 80,
      Unidad: "TRA 12"
    }
  ],
  workTime: [
    {
      Tiempo: 50,
      Unidad: "TRA 01"
    },
    {
      Tiempo: 40,
      Unidad: "TRA 02"
    },
    {
      Tiempo: 60,
      Unidad: "TRA 03"
    },
    {
      Tiempo: 10,
      Unidad: "TRA 04"
    },
    {
      Tiempo: 70,
      Unidad: "TRA 05"
    },
    {
      Tiempo: 55,
      Unidad: "TRA 06"
    },
    {
      Tiempo: 11,
      Unidad: "TRA 07"
    },
    {
      Tiempo: 5,
      Unidad: "TRA 08"
    },
    {
      Tiempo: 4,
      Unidad: "TRA 09"
    },
    {
      Tiempo: 100,
      Unidad: "TRA 10"
    },
    {
      Tiempo: 3,
      Unidad: "TRA 11"
    },
    {
      Tiempo: 80,
      Unidad: "TRA 12"
    }
  ]
};

const GeneralChartsTile = props => {
  const {
    data,
    units,
    lang,
    isActiveIdle,
    isActiveWorkTime,
    isActiveDistanceTraveled,
    isActiveDeadTime,
    onClickBullet,
    onMouseEnter,
    onMouseLeave
  } = props;

  const idle = data.Ralentis.map(r => ({
    Tiempo: r.TiempoRalenti,
    Unidad: r.DescripcionUnidad
  })).filter(r => r.Tiempo > 0);

  const traveledDistance = data.Ralentis.map(r => ({
    Distancia: r.DistanciaRecorrida,
    Unidad: r.DescripcionUnidad
  })).filter(r => r.Distancia > 0);

  const deadTime = data.TiemposMuertos.map(t => ({
    Tiempo: t.Tiempo,
    Unidad:
      units.filter(u => t.Unidad === u.Unidad).length > 0
        ? units.filter(u => t.Unidad === u.Unidad)[0].Descripcion
        : "no name"
  })).filter(t => t.Tiempo > 0);

  const workTime = data.TiemposMuertos.map(t => ({
    Tiempo: t.TiempoMovimiento,
    Unidad:
      units.filter(u => t.Unidad === u.Unidad).length > 0
        ? units.filter(u => t.Unidad === u.Unidad)[0].Descripcion
        : "no name"
  })).filter(t => t.Tiempo > 0);

  return (
    <div
      className="dashboard-tile"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {/* <TileIcon /> */}

      <Slide
        direction="left"
        timeout={{ exit: 0, enter: 1000 }}
        in={isActiveIdle}
        mountOnEnter
        unmountOnExit
      >
        <div>
          <div className="tile-header">{lang.Ralenti}</div>
          <div className="tile-chart-body">
            {idle.length > 0 ? (
              <IdleChart data={idle} lang={lang} />
            ) : (
              <Typography
                style={{ marginTop: "3rem", height: "7rem" }}
                variant="display1"
                align="center"
              >
                {lang.SinDatosAMostrar}
              </Typography>
            )}
          </div>
        </div>
      </Slide>
      <Slide
        direction="left"
        timeout={{ exit: 0, enter: 1000 }}
        in={isActiveWorkTime}
        mountOnEnter
        unmountOnExit
      >
        <div>
          <div className="tile-header">{lang.TiempoMovimiento}</div>
          <div className="tile-chart-body">
            {workTime.length > 0 ? (
              <WorkTimeChart data={workTime} lang={lang} />
            ) : (
              <Typography
                style={{ marginTop: "3rem", height: "7rem" }}
                variant="display1"
                align="center"
              >
                {lang.SinDatosAMostrar}
              </Typography>
            )}
          </div>
        </div>
      </Slide>
      <Slide
        direction="left"
        timeout={{ exit: 0, enter: 1000 }}
        in={isActiveDistanceTraveled}
        mountOnEnter
        unmountOnExit
      >
        <div>
          <div className="tile-header">{lang.DistanciaRecorrida}</div>
          <div className="tile-chart-body">
            {traveledDistance.length > 0 ? (
              <DistanceTraveledChart data={traveledDistance} lang={lang} />
            ) : (
              <Typography
                style={{ marginTop: "3rem", height: "7rem" }}
                variant="display1"
                align="center"
              >
                {lang.SinDatosAMostrar}
              </Typography>
            )}
          </div>
        </div>
      </Slide>
      <Slide
        direction="left"
        in={isActiveDeadTime}
        timeout={{ exit: 0, enter: 1000 }}
        mountOnEnter
        unmountOnExit
      >
        <div>
          <div className="tile-header">{lang.TiempoMuerto} </div>
          <div className="tile-chart-body">
            {deadTime.length > 0 ? (
              <DeadTimeChart data={deadTime} lang={lang} />
            ) : (
              <Typography
                style={{ marginTop: "3rem", height: "7rem" }}
                variant="display1"
                align="center"
              >
                {lang.SinDatosAMostrar}
              </Typography>
            )}
          </div>
        </div>
      </Slide>

      <div className="tile-footer">
        <div
          onClick={() => {
            onClickBullet("idle-chart");
          }}
          className={`slide-bullet ${isActiveIdle ? "selected" : ""}`}
        />
        <div
          onClick={() => {
            onClickBullet("work-time-chart");
          }}
          className={`slide-bullet ${isActiveWorkTime ? "selected" : ""}`}
        />
        <div
          onClick={() => {
            onClickBullet("distance-traveled-chart");
          }}
          className={`slide-bullet ${
            isActiveDistanceTraveled ? "selected" : ""
          }`}
        />
        <div
          onClick={() => {
            onClickBullet("dead-time-chart");
          }}
          className={`slide-bullet ${isActiveDeadTime ? "selected" : ""}`}
        />
      </div>
    </div>
  );
};

export const IdleChart = ({ data, lang }) => {
  const config = {
    type: "serial",
    theme: "light",
    chartScrollbar:
      data.length > 15
        ? {
            color: "#FFF"
          }
        : null,
    listeners: [
      {
        event: "drawn",
        method: chartDrawn
      }
    ],
    dataProvider: data.sort((a, b) => (a.Tiempo >= b.Tiempo ? false : true)),
    valueAxes: [
      {
        gridColor: "#FFFFFF",
        gridAlpha: 0.2,
        dashLength: 0,
        position: "left",
        title: lang.Minutos
      }
    ],
    gridAboveGraphs: true,
    startDuration: 1,
    graphs: [
      {
        balloonText: "[[category]]: <b>[[value]] Min.</b>",
        fillAlphas: 0.8,
        lineAlpha: 0.2,
        type: "column",
        valueField: "Tiempo"
      }
    ],
    chartCursor: {
      categoryBalloonEnabled: false,
      cursorAlpha: 0,
      zoomable: false
    },
    categoryField: "Unidad",
    categoryAxis: {
      gridPosition: "start",
      gridAlpha: 0,
      tickPosition: "start",
      tickLength: 20
    },
    export: {
      enabled: false
    }
  };

  return (
    <AmCharts.React
      style={{
        width: "100%",
        height: "10rem",
        fontSize: "10px",
        overflow: "hidden"
      }}
      options={config}
    />
  );
};

export const DeadTimeChart = ({ data, lang }) => {
  const config = {
    type: "serial",
    theme: "light",
    chartScrollbar:
      data.length > 15
        ? {
            color: "#FFF"
          }
        : null,
    listeners: [
      {
        event: "drawn",
        method: chartDrawn
      }
    ],
    dataProvider: data.sort((a, b) => (a.Tiempo >= b.Tiempo ? false : true)),
    valueAxes: [
      {
        gridColor: "#FFFFFF",
        gridAlpha: 0.2,
        dashLength: 0,
        position: "left",
        title: lang.Minutos
      }
    ],
    gridAboveGraphs: true,
    startDuration: 1,
    graphs: [
      {
        balloonText: "[[category]]: <b>[[value]] Min.</b>",
        fillAlphas: 0.8,
        lineAlpha: 0.2,
        type: "column",
        valueField: "Tiempo"
      }
    ],
    chartCursor: {
      categoryBalloonEnabled: false,
      cursorAlpha: 0,
      zoomable: false
    },
    categoryField: "Unidad",
    categoryAxis: {
      gridPosition: "start",
      gridAlpha: 0,
      tickPosition: "start",
      tickLength: 20
    },
    export: {
      enabled: false
    }
  };

  return (
    <AmCharts.React
      style={{
        width: "100%",
        height: "10rem",
        fontSize: "10px",
        overflow: "hidden"
      }}
      options={config}
    />
  );
};

export const DistanceTraveledChart = ({ data, lang }) => {
  const config = {
    type: "serial",
    theme: "light",
    chartScrollbar:
      data.length > 15
        ? {
            color: "#FFF"
          }
        : null,
    listeners: [
      {
        event: "drawn",
        method: chartDrawn
      }
    ],
    dataProvider: data.sort((a, b) => (a.Tiempo >= b.Tiempo ? false : true)),
    valueAxes: [
      {
        gridColor: "#FFFFFF",
        gridAlpha: 0.2,
        dashLength: 0,
        position: "left",
        title: lang.Distancia
      }
    ],
    gridAboveGraphs: true,
    startDuration: 1,
    graphs: [
      {
        balloonText: "[[category]]: <b>[[value]] Km</b>",
        fillAlphas: 0.8,
        lineAlpha: 0.2,
        type: "column",
        valueField: "Distancia"
      }
    ],
    chartCursor: {
      categoryBalloonEnabled: false,
      cursorAlpha: 0,
      zoomable: false
    },
    categoryField: "Unidad",
    categoryAxis: {
      gridPosition: "start",
      gridAlpha: 0,
      tickPosition: "start",
      tickLength: 20
    },
    export: {
      enabled: false
    }
  };

  return (
    <AmCharts.React
      style={{
        width: "100%",
        height: "10rem",
        fontSize: "10px",
        overflow: "hidden"
      }}
      options={config}
    />
  );
};

export const WorkTimeChart = ({ data, lang }) => {
  const config = {
    type: "serial",
    theme: "light",
    chartScrollbar:
      data.length > 15
        ? {
            color: "#FFF"
          }
        : null,
    listeners: [
      {
        event: "drawn",
        method: chartDrawn
      }
    ],
    dataProvider: data.sort((a, b) => (a.Tiempo >= b.Tiempo ? false : true)),
    valueAxes: [
      {
        gridColor: "#FFFFFF",
        gridAlpha: 0.2,
        dashLength: 0,
        position: "left",
        title: lang.Minutos
      }
    ],
    gridAboveGraphs: true,
    startDuration: 1,
    graphs: [
      {
        balloonText: "[[category]]: <b>[[value]] Min</b>",
        fillAlphas: 0.8,
        lineAlpha: 0.2,
        type: "column",
        valueField: "Tiempo"
      }
    ],
    chartCursor: {
      categoryBalloonEnabled: false,
      cursorAlpha: 0,
      zoomable: false
    },
    categoryField: "Unidad",
    categoryAxis: {
      gridPosition: "start",
      gridAlpha: 0,
      tickPosition: "start",
      tickLength: 20
    },
    export: {
      enabled: false
    }
  };

  return (
    <AmCharts.React
      style={{
        width: "100%",
        height: "10rem",
        fontSize: "10px",
        overflow: "hidden"
      }}
      options={config}
    />
  );
};

export const MovingTimeChart = ({ data, lang }) => {
  const config = {
    type: "serial",
    theme: "light",
    chartScrollbar:
      data.length > 15
        ? {
            color: "#FFF"
          }
        : null,
    listeners: [
      {
        event: "drawn",
        method: chartDrawn
      }
    ],
    dataProvider: data.sort((a, b) => (a.Tiempo >= b.Tiempo ? false : true)),
    valueAxes: [
      {
        gridColor: "#FFFFFF",
        gridAlpha: 0.2,
        dashLength: 0,
        position: "left",
        title: "Minutos"
      }
    ],
    gridAboveGraphs: true,
    startDuration: 1,
    graphs: [
      {
        balloonText: "[[category]]: <b>[[value]] Min</b>",
        fillAlphas: 0.8,
        lineAlpha: 0.2,
        type: "column",
        valueField: "Tiempo"
      }
    ],
    chartCursor: {
      categoryBalloonEnabled: false,
      cursorAlpha: 0,
      zoomable: false
    },
    categoryField: "Unidad",
    categoryAxis: {
      gridPosition: "start",
      gridAlpha: 0,
      tickPosition: "start",
      tickLength: 20
    },
    export: {
      enabled: false
    }
  };

  return (
    <AmCharts.React
      style={{
        width: "100%",
        height: "10rem",
        fontSize: "10px",
        overflow: "hidden"
      }}
      options={config}
    />
  );
};

export default GeneralChartsTile;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardTiles/GeneralChartsTile.js